export default "__VITE_ASSET__BFAvBNmQ__"